@if (groupedArticles) {
  <div [ngClass]="{ preorder: preorder }">
    <div class="mx-0 row">
      <div class="ps-2 col-12">
        @if (header) {
          <h4>
            @if (!compact && !checkout && showCheckoutOption && !basketLocked && groupId !== 'direct') {
              <input
                type="checkbox"
                [(ngModel)]="selected"
                (change)="selectAll($event)"
                id="type_{{ header }}"
                />
              }<label class="pt-1 mb-0 ps-2" for="type_{{ header }}">
              {{ header | translate }} <ng-content></ng-content>
              @if (!compact && showCheckoutOption) {
                <span
                  >({{ groupedArticles.checkoutCount }})</span
                  >
                  }</label
                  >
                </h4>
              }
            </div>
            <div class="col-6">
              <ng-content select="[select-week]"></ng-content>
            </div>
          </div>
          @if (!compact) {
            <ul
              class="mb-0 list-group list-group-flush col-md-12 ps-sm-1 ps-3"
              >
              @for (article of groupedArticles.items; track trackByItem(i, article); let i = $index) {
                @if (article.item_details && (preorder || (!preorder && (!article.is_mandatory || !article.parent_found))) && !checkout && (groupedArticles.items.length <= viewIndex || i < viewIndex)) {
                  <li
                    class="list-group-item ps-1"
                    >
                    @if (groupedArticles.items.length <= viewIndex || i < viewIndex) {
                      <app-basket-article
                        class="row"
                        [ngClass]="[article.children ? 'hasChildren' : '', preorder ? 'preorder-article' : '']"
                        [article]="article"
                        (articleSelectionChanged)="selectionChanged()"
                        (preorderQtyChanged)="editPreorder()"
                        [showCheckoutOption]="showCheckoutOption"
                        [basketId]="basketId"
                        [previewItem]="false"
                        [preorder]="preorder"
                        [showShopDropdown]="showShopDropdown"
                        [type]="type"
                        [parentArticle]="article"
                        [lockedDeliveryWeeks]="lockedDeliveryWeeks"
                        [basketLocked]="basketLocked"
                        [compact]="compactMode"
                        >
                        @if (
                          preorder &&
                          applicationService.getSelectCompanyGroupCode() !== 'ANL'
                          ) {
                          <div
                            class="col d-none d-sm-block"
                            >
                            <i class="material-icons clickable withOpacity" (click)="editPreorder()"> edit </i>
                          </div>
                        }
                      </app-basket-article>
                    }
                    @if (article.item_details && checkout) {
                      <app-checkout-article
                        [showShopType]="showShopDropdown"
                        [readonly]="readonly"
                        [article]="article"
                        [basketLocked]="basketLocked"
                      ></app-checkout-article>
                    }
                  </li>
                }
                @if (!article.item_details && !checkout) {
                  <li
                    class="list-group-item text-danger col-12 p-2 my-2 deleted-article rounded"
                    >
                    {{ article.article_code }} {{ "STATUS5" | translate }}
                    <button
                      class="btn btn-danger btn-sm"
                      (click)="deleteArticle(article)"
                      >
                      {{ "DELETE" | translate }}
                    </button>
                  </li>
                }
              }
              @if (!checkout && groupedArticles.items.length > viewIndex) {
                <li class="list-group-item bg-dark text-white text-center p-2 rounded clickable withOpacity" (click)="showMore()">{{"SHOW_MORE"|translate}} ({{viewIndex}} - {{nextResultsEnd(viewIndex, resultsPerView)}})</li>
              }
              @if (!checkout && groupedArticles.items.length > viewIndex) {
                <li class="list-group-item text-center clickable withOpacity mt-2" (click)="viewIndex = groupedArticles.items.length">{{"SHOW_ALL_ARTICLES"|translate}}</li>
              }
            </ul>
          }
          @if (compact) {
            <ul
              class="pb-0 mb-0 list-group list-group-flush col-md-12 ps-1 pe-0 pt-0 pt-sm-2"
              >
              @for (article of groupedArticles.items; track article) {
                @if (article.item_details && !article.is_mandatory) {
                  <li class="list-group-item">
                    <app-basket-article
                      class="row"
                      [article]="article"
                      (articleSelectionChanged)="selectionChanged()"
                      [basketId]="basketId"
                      [previewItem]="true"
                      [basketId]="basketId"
                      [basketLocked]="basketLocked"
                    ></app-basket-article>
                  </li>
                }
              }
            </ul>
          }
          @if (checkout) {
            <ul
              class="pb-0 mb-0 list-group list-group-flush col-md-12 ps-1"
              >
              @for (article of groupedArticles.items; track article) {
                @if (article.item_details && (preorder || (!preorder && (!article.is_mandatory || !article.parent_found)))) {
                  <li class="list-group-item">
                    <app-checkout-article
                      class="row"
                      [article]="article"
                      (articleSelectionChanged)="selectionChanged()"
                      [readonly]="readonly"
                      [preorder]="preorder"
                      [basketLocked]="basketLocked"
                      >
                    </app-checkout-article>
                  </li>
                }
              }
            </ul>
          }
          @if (!compact) {
            <ul
              class="pt-0 list-group list-group-flush total col-md-12 ps-1"
              >
              <li class="list-group-item">
                <div
                  class="row justify-content-end"
                  [ngClass]="checkout ? 'px-0 px-sm-4' : 'mx-0 ps-2'"
                  >
                  <div class="col-5 col-sm-3 text-start ps-0 pe-sm-3 showroom-notice text-end">
                    @if (showroomMode) {
                      <i class="opacity-50">{{"RETAIL_PRICE"|translate}}</i>
                    }
                  </div>
                  <div class="ps-4 col-md-2">
                    @if (preorder && checkout) {
                      @if (getQuantity('bicycle')) {
                        {{ "TOTAL" | translate }}
                        {{ ("BICYCLES" | translate).toLowerCase() }}:
                        {{ getQuantity("bicycle") }}
                      }
                      <br />
                      @if (getQuantity('part')) {
                        {{ "TOTAL" | translate }}
                        {{ ("PARTS" | translate).toLowerCase() }}:
                        {{ getQuantity("part") }}
                      }
                    }
                  </div>
                  <div class="text-end col-md-2 ps-sm-0 ps-md-4 text-md-left pt-1">
                    @if (preorder && !checkout) {
                      <span
                        class="ms-1 ps-sm-0 ps-md-2 ps-lg-2 ps-xl-4"
                        style="font-weight: bold"
                        >
                        {{ "QUANTITY" | translate }}: {{ getQuantity() }}
                      </span>
                    }
                  </div>
                  <div class="col-md-4 ps-0 text-end groupSum pe-2 pe-sm-2 me-1 pe-sm-0 pt-1">
                    <h5>{{ "TOTAL" | translate }}:&nbsp;<span [innerHTML]="sum | currencyConvert : currency"></span></h5>
                  </div>
                  <div class="col-md-12 d-flex justify-content-end pt-3 pe-2 pe-sm-3">
                    @if (checkout && coupons && coupons.length && !showroomMode) {
                      <button
                        type="button"
                        class="my-2 btn btn-success float-md-left d-block mt-md-0 "
                        (click)="openCouponModal()"
                        >
                        {{ "OPEN_COUPONS" | translate }}
                      </button>
                    }
                    @if (!showCheckoutOption && !checkout && preorder) {
                      <button
                        class="mt-4 me-2 btn btn-sm btn-dark mt-sm-0"
                        (click)="editPreorder()"
                        >
                        {{ "EDIT" | translate }}
                      </button>
                    }
                    @if (!showCheckoutOption && !checkout && preorder) {
                      <button
                        class="mt-4 btn btn-success mt-sm-0"
                        (click)="checkoutPreorderSelection()"
                        >
                        {{ "CHECKOUT" | translate }}
                      </button>
                    }
                  </div>
                </div>
              </li>
            </ul>
          }
          @if (compact) {
            <ul
              class="pb-0 mb-0 list-group list-group-flush col-md-12 ps-1 pe-0 pe-sm-3"
              >
              <li class="list-group-item">
                <div class="row">
                  <div class="w-100 d-flex justify-content-end">
                    <div class="ps-0 col-md-10"></div>
                    <div class="col-md-2 hideForShowroomMode sum groupSum ps-2 pe-3 pe-sm-2 me-sm-1">
                      <span [innerHTML]="sum | currencyConvert : currency"></span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          }
        </div>
      }
